import { render } from "./BlogShopifyLimitations.vue?vue&type=template&id=72a70cd2"
import script from "./BlogShopifyLimitations.vue?vue&type=script&lang=js"
export * from "./BlogShopifyLimitations.vue?vue&type=script&lang=js"

import "./BlogShopifyLimitations.vue?vue&type=style&index=0&id=72a70cd2&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__